import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "query-help-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.help')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", {
        style: _ctx.queryDescriptor.style.dialog,
        innerHTML: _ctx.$t('managers.datasetManagement.queryHelpDialog.paragraph1')
      }, null, 12, ["innerHTML"]),
      _createVNode("div", {
        style: _ctx.queryDescriptor.style.dialog,
        innerHTML: _ctx.$t('managers.datasetManagement.queryHelpDialog.paragraph2')
      }, null, 12, ["innerHTML"]),
      _createVNode("div", {
        style: _ctx.queryDescriptor.style.dialog,
        innerHTML: _ctx.$t('managers.datasetManagement.queryHelpDialog.list1')
      }, null, 12, ["innerHTML"]),
      _createVNode("div", {
        style: _ctx.queryDescriptor.style.dialog,
        innerHTML: _ctx.$t('managers.datasetManagement.queryHelpDialog.list2')
      }, null, 12, ["innerHTML"]),
      _createVNode("div", {
        style: _ctx.queryDescriptor.style.dialog,
        innerHTML: _ctx.$t('managers.datasetManagement.queryHelpDialog.list3')
      }, null, 12, ["innerHTML"]),
      _createVNode("div", {
        style: _ctx.queryDescriptor.style.dialog,
        innerHTML: _ctx.$t('managers.datasetManagement.queryHelpDialog.list4')
      }, null, 12, ["innerHTML"])
    ]),
    _: 1
  }, 8, ["visible"]))
}